import { render } from "./MobilePledgeBar.vue?vue&type=template&id=ba0dd0de"
import script from "./MobilePledgeBar.vue?vue&type=script&lang=js"
export * from "./MobilePledgeBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__